import React from 'react'
import { RouteStatus } from '@news-mono/web-common'
import { TheWestPageNotFound } from './TheWestPageNotFound'
import { createRegisterableComponent } from '@news-mono/web-common'

export const TheWestPageNotFoundRegistration = createRegisterableComponent(
    'west-404-page',
    () => (
        <RouteStatus statusCode={404}>
            <TheWestPageNotFound />
        </RouteStatus>
    ),
)
